/* eslint-disable no-restricted-imports */

import {
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import { LocalOffer, MonetizationOn, Save } from '@material-ui/icons';

import { GradientButton, useStyles } from '../styles';

export function CreateProductDialog({
  isOpen,
  handleClose,
  editingProduct,
  formik,
  processOptions,
  isLoading,
}) {
  const classes = useStyles();

  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle style={{ fontWeight: 600 }}>
        {editingProduct ? 'Editar Produto' : 'Adicionar Novo Produto'}
      </DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent dividers>
          <div className={classes.formRow}>
            <TextField
              fullWidth
              id='part_number'
              name='part_number'
              label='Part Number'
              variant='outlined'
              value={formik.values.part_number}
              onChange={formik.handleChange}
              error={formik.touched.part_number && Boolean(formik.errors.part_number)}
              helperText={formik.touched.part_number && formik.errors.part_number}
            />
          </div>

          <div className={classes.formRow}>
            <TextField
              fullWidth
              id='value'
              name='sell_price'
              label='Valor de Venda'
              type='number'
              variant='outlined'
              value={formik.values.sell_price}
              onChange={formik.handleChange}
              error={formik.touched.sell_price && Boolean(formik.errors.sell_price)}
              helperText={formik.touched.sell_price && formik.errors.sell_price}
              InputProps={{
                startAdornment: <MonetizationOn color='action' style={{ marginRight: 8 }} />,
              }}
            />

            <TextField
              fullWidth
              id='cost_price'
              name='cost_price'
              label='Valor de Custo'
              type='number'
              variant='outlined'
              value={formik.values.cost_price}
              onChange={formik.handleChange}
              error={formik.touched.cost_price && Boolean(formik.errors.cost_price)}
              helperText={formik.touched.cost_price && formik.errors.cost_price}
              InputProps={{
                startAdornment: <LocalOffer color='action' style={{ marginRight: 8 }} />,
              }}
            />
          </div>

          {!editingProduct && (
            <FormControl fullWidth variant='outlined' size='small' style={{ marginTop: 16 }}>
              <InputLabel>Processos aplicáveis</InputLabel>
              <Select
                multiple
                id='process'
                name='process'
                value={formik.values.process}
                onChange={formik.handleChange}
                renderValue={(selected) => (
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {(selected || []).map((value) => {
                      return (
                        <Chip
                          key={value}
                          label={processOptions.find((p) => p.value === value)?.label || value}
                          className={classes.processChip}
                          size='small'
                        />
                      );
                    })}
                  </div>
                )}
                error={formik.touched.process && Boolean(formik.errors.process)}
              >
                {processOptions.map((process) => (
                  <MenuItem key={process.value} value={process.value}>
                    <Checkbox checked={formik.values.process.indexOf(process.value) > -1} />
                    <ListItemText primary={process.label} />
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.process && formik.errors.process && (
                <Typography color='error' variant='caption'>
                  {formik.errors.process}
                </Typography>
              )}
            </FormControl>
          )}
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            onClick={handleClose}
            style={{ borderRadius: 8 }}
            startIcon={isLoading && <CircularProgress size={18} color='inherit' />}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <GradientButton
            type='submit'
            variant='contained'
            endIcon={isLoading ? <CircularProgress size={18} /> : <Save />}
            disabled={isLoading}
          >
            {editingProduct ? 'Atualizar' : 'Salvar'}
          </GradientButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}
